/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-pmm-5]{display:block;border:1px solid!important}[_ngcontent-pmm-6],h3[_ngcontent-pmm-6]{background-color:var(--background-primary)!important;border:1px solid!important}.input-icon{position:absolute;right:8px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer}"];
export { styles as styles };
